let id = 1

export default function getId() {
  return id++
}
